import React, { Component } from 'react';
import tablog from '../images/tablog.svg';
import { NavLink } from "react-router-dom";
import '../styles/SideBar.scss';
import { Fragment } from 'react';
import "../styles/bootstrap.min.css";
import { withTranslation } from 'react-i18next';
import { getPoolInformation, getTenantLanguages } from '../services/tenant-identity-service';
import { getLocation } from '../services/branch-service';
import { getTokenDetailsByDecoding } from '../services/cookie-storage-service';

class SideBar extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            showNavBar: true,
            tenantData: {},
            locationArr: [],
            languageArr: []
        }
    }

    componentDidMount = async () => {
        let tenantGuid = getTokenDetailsByDecoding().tenantGuid;
        this.getTenantDetails(tenantGuid);
        this.getAllLanguages();
        await this.getBranch();
    }

    getBranch = async () => {
        try {
            let response = await getLocation();

            if (response) {
                let locationResult = response.data.getBranch;
                this.setState({ locationArr: locationResult });
            }
        } catch (error) {
            console.log('getBranch error', error);
        }

        // this.setState({ isLoading: false });
    }

    getAllLanguages = async () => {
        let languageResult = [];
        let tenantGuid = localStorage.getItem("tenantGuid");
        languageResult = await getTenantLanguages(tenantGuid);

        if (languageResult.length > 0) {
            let result = languageResult[0].languageGuid;
            this.setState({ languageArr: result });
        }
    }

    getTenantDetails = async (tenantGuid) => {
        try {
            let tenantData = await getPoolInformation(tenantGuid);
            this.setState({ tenantData: tenantData });
        } catch (error) {
            console.log('getTenantDetails error', error);
        }
    }

    toggleNavBar = () => {
        this.setState({ showNavBar: !this.state.showNavBar });
    }

    navigate = (e, path) => {
        let pagename = path.substr(1,);
        let currentClass = e.target.className;

        if (currentClass === "disable") {
            e.preventDefault();
        } else if (currentClass === "default") {
            this.props.history.push({
                pathname: path,
                state: {
                    pagename: pagename,
                    className: 'active'
                }
            });
        }
        else {
            this.props.history.push({
                pathname: path,
                state: {
                    pagename: pagename,
                    className: 'active'
                }
            });
        }
    }

    render() {
        const { t } = this.props;
        let tenantData = this.state.tenantData;
        let propsState = this.props.location.state;
        let currentPage = this.props.location.pathname.substr(1,);
        let locationCount = localStorage.getItem('locationCount');

        let isTenantPurchased = JSON.parse(localStorage.getItem('isTenantPurchased'));
        let isLocationEnabled = false;

        if (isTenantPurchased) {
            isLocationEnabled = true;
        } else if (locationCount > 0) {
            isLocationEnabled = true;
        }

        let active = {
            borderRadius: 'unset',
            fontSize: '14px',
            fontWeight: 'bold',
            color: '#10aee5',
        }

        let disable = {
            borderRadius: 'unset',
            fontSize: '14px',
            fontWeight: 'bold',
            color: '#bbbbbb',
        }

        return (
            <Fragment>
                <div className="mobile-tab">
                    <nav className="navbar navbar-expand-lg navbar-light">
                        <div className="navbar-brand">
                            <NavLink to="/Summary"><img src={tablog} className="img-fluid" alt="" /></NavLink>
                        </div>
                        <button className="navbar-toggler" type="button" data-toggle="collapse"
                            data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false"
                            aria-label="Toggle navigation" onClick={this.toggleNavBar}>
                            <span className="navbar-toggler-icon"></span>
                        </button>
                        {
                            !this.state.showNavBar ? (
                                <div className="navbar-collapse" id="navbarNav">
                                    <ul className="navbar-nav">
                                        <li className="nav-item" key="Language">
                                            <div style={currentPage === 'Language' && this.state.languageArr > 0 ? active : disable} onClick={(e) => { this.navigate(e, '/Language') }}>LANGUAGES</div>
                                        </li>
                                        <li className="nav-item" key="Summary">
                                            <div style={currentPage === 'Summary' ? active : disable} onClick={(e) => { this.navigate(e, '/Summary') }}>SUMMARY</div>
                                        </li>
                                        <li className="nav-item" key="Location">
                                            <div style={currentPage === 'Location' && this.state.locationArr > 0 ? active : disable} onClick={(e) => { this.navigate(e, '/Location') }}>LOCATIONS</div>
                                        </li>

                                        <li className="nav-item" key="Products">
                                            <div style={currentPage === 'Products' ? active : disable} onClick={(e) => { this.navigate(e, '/Products') }}>PRODUCTS</div>
                                        </li>
                                    </ul>
                                </div>
                            ) : null
                        }
                    </nav>
                    <h5><span>{t('Hello')} </span> {this.props.auth.tenantUserName}</h5>
                    <p>{t('username')} | {this.state.locationArr.length} locations</p>
                </div>
                <div className="main-tab">
                    <div className="tab-top">
                        <div to="/Summary"><img src={tablog} className="img-fluid" alt="" /></div>
                        {this.props.auth.isAuthenticated && this.props.auth.user && (
                            <h5>
                                <span>{t('Hi,')} </span> {this.props.auth.tenantUserName}
                            </h5>
                        )}
                        <p>{t('username')} | {this.state.locationArr.length} {t('locations')}</p>
                    </div>

                    {
                        tenantData ? (
                            <Fragment>
                                <div className="nav-pills">
                                    <div className={currentPage === 'Summary' ? "active" : "default"} onClick={(e) => { this.navigate(e, '/Summary') }}>{t('SUMMARY')}</div>

                                    <div className={currentPage === 'Language' && propsState ? propsState.className : "default"} style={{ color: '' }} onClick={(e) => { this.navigate(e, '/Language') }}>{t('LANGUAGE')}</div>

                                    {/* {
                                        this.state.languageArr.length > 0 ? (
                                            <div className={currentPage === 'Language' && propsState ? propsState.className : "default"} style={{ color: '' }} onClick={(e) => { this.navigate(e, '/Language') }}>{t('LANGUAGE')}</div>
                                        ) :
                                            (
                                                <div className="disable" onClick={(e) => { this.navigate(e, '/Language') }}>LANGUAGES</div>
                                            )
                                    } */}


                                    {
                                        (isLocationEnabled) ? (
                                            <Fragment>
                                                <div className={currentPage === 'Location' && propsState ? propsState.className : "default"} onClick={(e) => { this.navigate(e, '/Location') }}>{t('LOCATION')}</div>
                                                <div className={currentPage === 'Products' && propsState ? propsState.className : "default"} onClick={(e) => { this.navigate(e, '/Products') }}>{t('PRODUCT')}</div>
                                                <div className={currentPage === 'AddOns' && propsState ? propsState.className : "default"} onClick={(e) => { this.navigate(e, '/AddOns') }}>{t('ADD-ON')}</div>
                                                <div className={currentPage === 'Purchases' && propsState ? propsState.className : "default"} onClick={(e) => { this.navigate(e, '/Purchases') }}>{t('BUY LICENSE')}</div>
                                                <div className={currentPage === 'Reports' && propsState ? propsState.className : "default"} onClick={(e) => { this.navigate(e, '/Reports') }}>{t('REPORT')}</div>
                                                {/* <div className={currentPage === 'Help' && propsState ? propsState.className : "default"} onClick={(e) => { this.navigate(e, '/Help') }}>{t('HELP')}</div> */}
                                            </Fragment>
                                        ) : (
                                            <Fragment>
                                                <div className="disable" onClick={(e) => { this.navigate(e, '/Location') }}>{t('LOCATION')}</div>
                                                <div className="disable" onClick={(e) => { this.navigate(e, '/AddOns') }}>{t('Add_On')}</div>
                                                <div className="disable" onClick={(e) => { this.navigate(e, '/Products') }}>{t('PRODUCT')}</div>
                                                <div className="disable" onClick={(e) => { this.navigate(e, '/Purchases') }}>{t('PURCHASE')}</div>
                                                <div className="disable" onClick={(e) => { this.navigate(e, '/Reports') }}>{t('REPORTS')}</div>
                                                {/* <div className="disable" onClick={(e) => { this.navigate(e, '/Help') }}>{t('HELP')}</div> */}
                                            </Fragment>
                                        )
                                    }
                                </div>
                            </Fragment>
                        ) : null
                    }
                </div>
            </Fragment>
        )
    }
}
export default withTranslation()(SideBar)
